import { render, staticRenderFns } from "./BatchItemList.vue?vue&type=template&id=5b9f12a5&scoped=true"
import script from "./BatchItemList.vue?vue&type=script&lang=js"
export * from "./BatchItemList.vue?vue&type=script&lang=js"
import style0 from "./BatchItemList.vue?vue&type=style&index=0&id=5b9f12a5&prod&scoped=true&lang=css"
import style1 from "./BatchItemList.vue?vue&type=style&index=1&id=5b9f12a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f12a5",
  null
  
)

export default component.exports